import React from 'react'
import Copy from 'images/modules/Manage/i-copy.svg?raw'

export { default as CopyUrl } from 'images/modules/Manage/i-copy.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: Copy}} />
)
